import LogIn from './LogIn';

const App = () => <LogIn />;

export default App;
